import React, { Component } from "react";
import { savePDF } from "@progress/kendo-react-pdf";
import logo from "../../assets/img/logo.png";
import md1 from "../../assets/img/ma1.PNG";
import md2 from "../../assets/img/ma2.PNG";
import co2 from "../../assets/img/Green Gift Certificate-03.png"
import drop from "../../assets/img/Green Gift Certificate-04.png"
import temp from "../../assets/img/Green Gift Certificate-05.png"
import config from "../../config/axios/config.json";
import shape1 from "../../assets/img/shape1.png"
import shape2 from "../../assets/img/shape2.png"
import lshape from "../../assets/img/L shape.png"
import EllipseImageCurve from "./EllipseImageCurve";
import CircleImageCurve from "./CircleImageCurve";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../components/loader";
import Certificate from "../Certificate";
import "../../components/Certificate.css";

var QRCode = require("qrcode.react");
// const Cryptr = require("cryptr");
// const cryptr = new Cryptr("myTotalySecretKey");
const Mode = config.Application.mode;
const APIURL = config["CommonConstants"].web[Mode];

//export default class Certificate extends Component
export default class Dynamiccerficate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CurrentUser: {},
      Refrence: [],
      WillEncrypt: "",
      Singledownload: false,
      loader: false,
    };

    this.bodyRef = React.createRef();
  }

  Export = (index) => {
    let filteredUserList = this.props.userData;
    if (filteredUserList.length > index) {
      let value = filteredUserList[index];
      if (value.CheckedForPdf) {
        value.CheckedForPdf = false;
        this.savepdfbyasync(index, value.CustomerName).then((data) => {
          this.Export(index + 1);
        });
      } else {
        this.Export(index + 1);
      }
    } else {
      this.setState({ loader: false });
    }
  };
  createPdf = () => {
    if (document.getElementsByClassName("MainId")) {
      document.getElementsByClassName("MainId")[0].checked = false;
    }
    const htmlButtons = document.getElementsByClassName("Checking");
    const htmlButtonsArray = [...htmlButtons];
    htmlButtonsArray.map((button) => (button.checked = false));
    this.Export(0);
  };

  // kendoreact
  savepdfbyasync = (index, CustomerName) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        savePDF(
          this[`body${index}`].current,
          {
            paperSize: "A3",
            landscape: "true",
            fileName: CustomerName.split(".").join(" "),
          },
          () => {
            resolve("Success " + CustomerName);
          }
        );
      }, 15000); // 10 seconds
    });
  };


  render() {
    this.props.userData.map((a, b) => {
      this[`body${b}`] = React.createRef();
    });
    if (sessionStorage.getItem("pressed") != "") {
      sessionStorage.setItem("pressed", "");
      setTimeout(() => {
        this.createPdf();
        this.setState({ Singledownload: true, loader: true });
      }, 500);
    }
    return (
      <>
        <Loader loader={this.state.loader}></Loader>
        <section className="pdf-container">
          <section className="pdf-toolbar">
            <button
              className="Toolbutton"
              onClick={(e) => {
                if (this.props.userData.length > 0) {
                  this.setState({ loader: true });
                  this.createPdf();
                } else {
                  toast.warning("Select atleast 1 certificate to download");
                }
              }}
            >
              Download Selected Certificate
            </button>
          </section>
          <div style={{ overflow: "hidden", height: 0, width: 0 }}>
            {/* <div> */}
            {this.props.userData.map((value, index) => {
              const nameLength = value?.CustomerName?.length || 0;
              return (
                <section className="pdf-body" ref={this[`body${index}`]} style={{ fontFamily: "LiberationSans" }}>
                  <div className="Toexport" >
                    <div className="Certificate">
                      <div class="mainContainer" >
                        <div className="ccertificate-container">
                          <div className="ccertificate-box">

                            {/* Top Left Banner */}
                            <div className="top-header">
                              <div className="certbanner">
                                <div>Wishing you a
                                prosperous 2026!</div>
                              </div>

                              {/* Top Right Logo */}
                              <div className="logo">
                                <img src={logo} class="logoImg" alt="Logo" />
                              </div>
                            </div>


                            <div className="certcontent">

                              {/* Left Content */}
                              <div className="left-section">
                                <div className="dear">{value.CertNo == "INTGG2417" ? "To" : "Dear"}</div>
                                <div
                                  className="name"
                                  style={{
                                    fontSize:
                                      nameLength > 0 ?
                                        nameLength < 21
                                          ? "56px"
                                          : nameLength < 27
                                            ? "48px"
                                            : nameLength < 34
                                              ? "40px"
                                              : "40px"
                                        : "40px",
                                    lineHeight: 1.1
                                  }}
                                >
                                  {value?.CustomerName || ""}
                                </div>

                                <div className="dotted-line"></div>

                                <div className="message" >
                                  Thank you for becoming part of our sustainable future. As we step into 2026,
                                  we wish you a year of health, growth, and progress.
                                </div>
                                <div className="signature-section" style={{
                                  marginBottom:
                                    nameLength < 21
                                      ? "70px"
                                      : nameLength < 27
                                      ? "78px"
                                      : nameLength < 34
                                        ? "86px"
                                        : "45px",
                                }}>

                                  <div className="signatures">
                                    <div>
                                      <span className="signature-sign sign1 signature-line">
                                        SRIRAM SUBRAMANYA
                                      </span>
                                    </div>

                                    <div style={{ marginBottom: "10px" }}>
                                      <span className="signature-sign sign1 signature-line">
                                        ANU SRIRAM
                                      </span>
                                    </div>
                                  </div>

                                  <div className="signatures">
                                    <div >
                                      <div className="signature-font" style={{ marginLeft: "30px", marginTop: "10px" }}>Founder, MD & CEO</div>
                                    </div>

                                    <div>
                                      <div className="signature-font" style={{ marginTop: "10px" }}>Co-founder & JMD</div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Right Image */}
                              <div className="right-section">
                                <img
                                  src={`https://qrgreencode.blob.core.windows.net/qrcode/QRCode/${value.CertNo}.jpg?v=1`}
                                  alt="Tree"
                                  className="tree-image"
                                />
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="page2">

                          {/* Border */}
                          <div className="page2-border">

                            {/* Logo */}
                            <div className="page2-logo">
                              <img src={logo} class="logoImg logoImg2" alt="Logo" />
                            </div>

                            <div className="page2-content">

                              {/* LEFT GREEN PANEL */}
                              <div className="green-panel">

                                <p className="panel-title">
                                  A remarkable species, your tree boosts the environment in significant ways
                                </p>

                                <div className="stats">
                                  <div className="stat">
                                    <img className="icon" src={co2} alt="co2" width={50} height={50} />
                                    <p>
                                      It actively absorbs around {value.CarbonConsumption} pounds of carbon dioxide annually
                                      and provides life-sustaining oxygen.
                                    </p>
                                  </div>

                                  <div className="stat">
                                    <img className="icon" src={drop} alt="droplet" width={50} height={50} />
                                    <p>
                                      By intercepting roughly {value.Rainfall} gallons of rainfall annually,
                                      it contributes significantly to water conservation efforts.
                                    </p>
                                  </div>

                                  <div className="stat">
                                    <img className="icon" src={temp} alt="co2" width={50} height={50} />
                                    <p>
                                      It effectively reduces the local temperature by {value.AtmosphericTemp} degrees,
                                      creating a more pleasant atmosphere.
                                    </p>
                                  </div>
                                </div>

                                <div className="tree-info">
                                  <p>
                                  {value.Treeinfo.TreeDescription || ""}
                                  </p>
                                </div>

                              </div>

                              {/* RIGHT SIDE */}
                              <div className="right-panel">
                                <img
                                  src={`https://qrgreencode.blob.core.windows.net/qrcode/QRCode/${value.CertNo}_2.jpg?v=1`}
                                  alt="Tree"
                                  className="tree-photo"
                                />

                                <div className="qr-section">
                                  <a href={`https://integraforest.com/UserPage/?id=${btoa(value.ID)}`}>
                                    <QRCode
                                      value={`https://integraforest.com/UserPage/?id=${btoa(value.ID)}`}
                                      style={{
                                        width: "110px",
                                        height: "110px",
                                        position: "relative",
                                        backgroundColor: "#fff",
                                      }}
                                    ></QRCode>
                                  </a>
                                  <p>Experience Your<br />
                                    New Digital Certificate</p>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ToastContainer
                      autoClose={3500}
                      hideProgressBar={true}
                      limit={0}
                      draggable={false}
                      position={toast.POSITION.TOP_RIGHT}
                    ></ToastContainer>
                  </div>
                </section>
              );
            })}
          </div>
        </section>
      </>
    );
  }
}
